/**
 * 파일명 : com0104p.tsx
 * 설명 : 부서선택
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0101p4Action } from '../../../redux/slice/com/com0101p4_slice';
import { IInquiryCndsState, IDeptTreeState } from '../../../redux/models/com/com0101p4_model';

/* AntD */
import { Layout, Row, Col, Space, Button, Tree, Table, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { GetComponentProps } from 'rc-table/lib/interface';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 선언영억
 ************************************************/
const Com0101p1 = (props:any) => {
	/** State / Ref / Reducer 선언 **/
    const dispatch = useAppDispatch();
    const deptTree   = useAppSelector((state) => state.Com0101p4.deptTree);
    const treeKey    = useAppSelector((state) => state.Com0101p4.treeKey);

    let myDeptNode:IDeptTreeState;
    const nodeRefs = React.useRef<Record<string, HTMLSpanElement | null>>({});


    /************************************************
     * 화면 초기화 이벤트
     ************************************************/
    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     **/
    React.useEffect(() => {
        if (!deptTree || deptTree.length < 1) {
            // 입력파라미터
            const requestData = {};
    
            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0003',
                success : (responseData:any) => {
                    console.log(responseData.deptTree);
                    dispatch(Com0101p4Action.setDeptTree(responseData.deptTree));
                    dispatch(Com0101p4Action.setMaxLvlCd(responseData.lastLvl));
                },
            });
        }
    }, []);

    const findNodeMyDept = (treeData:IDeptTreeState[]) => {
        for (const node of treeData) {
            if (node.key === common.getDeptCd()) return node;
      
            if (node.children) {
                const found:IDeptTreeState = findNodeMyDept(node.children);

                if (found) return found;
            }
        }
        return null;
    };

    React.useEffect(() => {
        if (deptTree && deptTree.length > 0 && (!myDeptNode || Object.keys(myDeptNode).length < 1)) {
            myDeptNode = findNodeMyDept(deptTree);

            if (myDeptNode) {
                setDeptUsers(myDeptNode.key);
            }
        }
    }, [deptTree]);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnClose': {
                props.cancel();
                break;
            }
            case 'btnOk': {
                props.accept(treeKey);
                break;
            }
            default:
        }
    };

    /**
     * 기능 : Tree 선택 이벤트 선언
     * param : 
     */
    const onSelect = (_keys:any, event:any) => {
        setDeptUsers(event.node.key);
    };

    const setDeptUsers = (deptCd:string) => {
        dispatch(Com0101p4Action.setTreeKey(deptCd));

        if (deptCd && nodeRefs.current[deptCd]) {
            nodeRefs.current[deptCd].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }

    /************************************************
     * 개발자함수 영역
     ************************************************/


    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */


     /* Render 변수 선언영역 */
     /* AntD */
     const { Content } = Layout;
     const { Text }    = Typography;

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Row>
                    <Col style={{width : '100%', height : '500px'}}>
                        {deptTree && deptTree.length > 0 ?
                        <Tree
                            showLine
                            prefixCls='dept-tree'
                            className='dept-tree'
                            defaultExpandAll={true}
                            onSelect={onSelect}
                            treeData={deptTree}
                            selectedKeys={[treeKey]}
                            style={{maxHeight : '500px', overflowY : 'auto'}}
                            titleRender={(nodeData) => (
                                <span ref={(el) => {
                                    if (el) {
                                        nodeRefs.current[nodeData.key] = el;
                                    }
                                }}>
                                    {nodeData.title}
                                </span>
                              )}
                        /> : null}
                    </Col>
                </Row>
                <Row justify='center'>
                    <Col>
                        <Space direction='vertical'>
                            <Row justify='space-around' style={{ marginTop: 20 }}>
                                <Space size='small'>
                                    <Button
                                        name='btnClose'
                                        className='background-color-default-button'
                                        onClick={onClick}
                                    >
                                        닫기
                                    </Button>
                                    <Button
                                        name='btnOk'
                                        className='background-color-primary-button'
                                        onClick={onClick}
                                    >
                                        확인
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0101p1;